// hasName: childName !== null; the other branch is the no-name wording.
export const invite = {
  entryTitle: 'Link to {hasName, select, true {{childName}} other {your child}}',
  entrySignedOutBody:
    '{hasName, select, true {{childName}} other {Your child}} invited you to Tupai. Use your own account to link as their parent.',
  createAccount: 'Create account',
  haveAccount: 'I already have an account',
  savedNote: 'Your invitation is saved while you sign up or log in.',
  entrySignedInBody:
    '{hasName, select, true {{childName}} other {Your child}} invited you to follow their maths on Tupai.',
  loggedInAs: 'Logged in as',
  switchAccount: 'Switch',
  continueCta: 'Continue',
  checking: 'Checking…',

  fullTitle: 'Your plan is full',
  // hasPlan: planName set and seats !== null.
  fullBody:
    '{hasPlan, select, true {{planName} covers {seats, plural, one {{seats} child} other {{seats} children}}, and {seats, plural, one {that place is} other {those places are}} taken. Change your plan to link {hasName, select, true {{childName}} other {your child}}.} other {Your plan has no free place left. Change your plan to link {hasName, select, true {{childName}} other {your child}}.}}',
  freeFullTitle: 'Your Free plan has 1 child already',
  freeFullBody:
    "Free covers 1 child. {hasName, select, true {{childName}} other {Your child}} can't be linked on this plan.",
  freePlanLabel: 'Free plan',
  freeUpgradeNote: 'Family Solo still covers 1 child. Family Duo adds a second child.',
  freeUpgradeCta: 'Upgrade to Family Duo',
  freeNotLinked: '{hasName, select, true {{childName}} other {Your child}} is not linked',
  freeCurrentStays: 'Your current child stays linked.',
  syllabusTitle: "Your plan doesn't cover this syllabus",
  syllabusBody:
    '{hasName, select, true {{childName}} other {Your child}} studies a syllabus that is not part of your plan. Change your plan to link {hasName, select, true {{childName}} other {your child}}.',
  keptTitle: 'Your invitation is kept',
  keptBody: 'You can come back to this link for 24 hours.',

  alreadyLinkedTitle: '{hasName, select, true {{childName}} other {Your child}} is already linked',
  alreadyLinkedBody:
    "{hasName, select, true {{childName}} other {Your child}} is already linked to this account. There's nothing else to do.",
  goToChildren: 'Go to Children',
  takenTitle: 'This child is already linked',
  expiredTitle: 'This link has expired',
  expiredBody:
    'Invitation links work for 24 hours. Ask your child to send a new one from Student Tupai.',
  invalidTitle: "This link doesn't work",
  invalidBody: 'It may have been used already or copied wrongly. Ask your child to send a new one.',
  openParent: 'Open Tupai Parent',
  errorTitle: "We couldn't link just now",
  errorBody: 'Check your connection and try again.',
  tryAgain: 'Try again',

  laterTitle: 'No consent given',
  laterBody:
    "{hasName, select, true {{childName}} other {Your child}} is not linked yet. {isUnder13, select, true {An under-13 child also can't finish signing up. } other {}}This link still works for 24 hours.",
  giveConsentNow: 'Give consent now',
  close: 'Close',

  allSetTitle: 'All set',
  allSetBody: '{hasName, select, true {{childName}} other {Your child}} is linked to your account.',
  handBackTitle: 'Hand the phone back to {hasName, select, true {{childName}} other {your child}}',
  handBackBody:
    "You're logged out of this phone. Open Tupai Parent on your own phone to follow {hasName, select, true {{childName}} other {your child}}.",
  handBackSavedBody:
    "{hasName, select, true {{childName}} other {Your child}} is not linked yet. You're logged out of this phone. Open this link on your own phone within 24 hours to link.",
  handBackEndedBody: "You're logged out of this phone.",
} as const;
